/* WEDO lang/UA blocker v3.4 (single-hit + Asia/Shanghai-only TZ)
   - 触发策略：命中任意一项(语言/UA/时区/GeoIP) 即拦截
   - 时区：仅命中 Asia/Shanghai，不再使用 UTC+08:00 偏移，避免误伤
   - 放行方式：localStorage.allow_access === '1'、?allow=1&hrs=24、?sword=888
   - 错误页：Chrome 风格（图2样式）
*/

(function () {
  "use strict";

  // === CONFIG ===
  var USE_TZ_CHECK = true;         // 只用 Asia/Shanghai 判定。要关闭时区判定，改为 false
  var SECRET_PARAM = "sword";      // 维护口令参数名
  var SECRET_VALUE = "888";        // 维护口令值
  var BYPASS_PARAM = "allow";      // ?allow=1
  var BYPASS_HOURS_PARAM = "hrs";  // ?allow=1&hrs=24
  var LOCAL_KEY_TS = "wedo_allow_until";
  var LOCAL_KEY_FLAG = "wedo_admin_pass_2026"; // 控制台放行：localStorage.setItem('wedo_admin_pass_2026','1')
  var DEBUG = false;

  // === 固定白名单（后台/预览/本机放行等） ===
  try {
    var href = location.href;
    var qsTemp = new URLSearchParams(location.search);
    if (
      (qsTemp.get(SECRET_PARAM) === SECRET_VALUE) ||
      href.indexOf("/admin") > -1 ||
      href.indexOf("design_mode=true") > -1 ||
      href.indexOf("preview_theme_id") > -1 ||
      href.indexOf("_fd=0") > -1 ||
      (window.Shopify && window.Shopify.designMode) ||
      (+localStorage.getItem(LOCAL_KEY_TS) || 0) > Date.now() ||
      (String(localStorage.getItem(LOCAL_KEY_FLAG)) === "1")
    ) {
      if (DEBUG) console.log("[WEDO] safe-exit: whitelist matched");
      return;
    }
  } catch (e) {}

  // === URL 临时放行 ?allow=1&hrs=24 ===
  try {
    var qs = new URLSearchParams(location.search || "");
    if (qs.get(BYPASS_PARAM) === "1") {
      var hrs = Math.max(1, Math.min(72, parseInt(qs.get(BYPASS_HOURS_PARAM) || "24", 10)));
      localStorage.setItem(LOCAL_KEY_TS, String(Date.now() + hrs * 3600 * 1000));
      if (DEBUG) console.log("[WEDO] temp allow set for", hrs, "hours");
      return;
    }
  } catch (e) {}

  // === 命中判定 ===
  var hits = [];

  // 1) 语言（只要含 zh 即命中）
  try {
    var langs = (navigator.languages || []).join(",").toLowerCase();
    var lang1 = (navigator.language || navigator.userLanguage || "").toLowerCase();
    if (langs.indexOf("zh") !== -1 || /^zh\b/.test(lang1)) hits.push("lang");
  } catch (e) {}

  // 2) UA（常见中文环境/超级 App）
  try {
    var ua = (navigator.userAgent || "").toLowerCase();
    if (/(micromessenger|alipayclient|baiduboxapp|baidu|ucbrowser|qqbrowser|miuibrowser|sogou|qhbrowser|hejibrowser)/.test(ua)) {
      hits.push("ua");
    }
  } catch (e) {}

  // 3) 时区（仅命中 Asia/Shanghai）
  if (USE_TZ_CHECK) {
    try {
      var tzName = Intl && Intl.DateTimeFormat ? (Intl.DateTimeFormat().resolvedOptions().timeZone || "").toLowerCase() : "";
      if (tzName.indexOf("asia/shanghai") !== -1) hits.push("tzname");
      // 注意：不再使用 getTimezoneOffset() === -480，避免误伤其他 UTC+08:00 地区
    } catch (e) {}
  }

  // 4) Geo/IP 插件勾子（若在别处设置 window.__CN_IP__ = true 即命中）
  try {
    if (window.__CN_IP__ === true) hits.push("geoip");
  } catch (e) {}

  if (DEBUG) console.log("[WEDO] hits:", hits);

  // === 触发策略：命中任意一项就拦截 ===
  var shouldBlock = hits.length >= 1;
  if (!shouldBlock) {
    if (DEBUG) console.log("[WEDO] not blocked");
    return;
  }

  // === 渲染 Chrome 风格错误页（图2样式） ===
  try {
    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (m) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":"&#39;"}[m]); });
    }

    var html =
      '<!doctype html><html><head>' +
        '<meta charset="utf-8">' +
        '<meta name="robots" content="noindex,nofollow">' +
        '<meta name="viewport" content="width=device-width, initial-scale=1">' +
        '<link rel="icon" href="data:," />' +
        '<style>' +
          'html,body{height:100%;margin:0;background:#fff;color:#222;font-family:"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif}' +
          '.wrap{height:100%;display:flex;align-items:center;justify-content:center}' +
          '.card{max-width:640px;padding:24px;text-align:left}' +
          '.top{display:flex;align-items:flex-start;gap:16px}' +
          '.icon-box{width:48px;height:48px;background:#efefef;border-radius:6px;display:flex;align-items:center;justify-content:center;flex:0 0 48px}' +
          '.face{width:26px;height:26px;position:relative;display:block}' +
          '.face:before{content:"";position:absolute;left:50%;top:50%;transform:translate(-50%,-56%);width:16px;height:2px;background:#9aa0a6;border-radius:2px}' +
          '.face:after{content:"";position:absolute;left:50%;top:50%;transform:translate(-50%,8px);width:6px;height:6px;background:#9aa0a6;border-radius:2px}' +
          '.h{font-size:20px;margin:0 0 6px;color:#202124}' +
          '.d{font-size:15px;margin:0 0 12px;color:#5f6368;line-height:1.4}' +
          '.suggest{margin:10px 0 12px;padding-left:18px;color:#5f6368;line-height:1.6}' +
          '.suggest li{margin:6px 0}' +
          '.errcode{font-family:monospace;color:#6c6f73;font-size:13px;margin-top:8px}' +
          '.btns{margin-top:18px}' +
          '.btn{display:inline-block;min-width:96px;padding:8px 14px;border-radius:4px;border:1px solid #cfd8e3;background:#fff;cursor:pointer;font-size:14px;margin-right:8px}' +
          '.btn.primary{background:#1677ff;border-color:#1677ff;color:#fff;box-shadow:0 1px 0 rgba(0,0,0,0.04)}' +
          '.btn.secondary{background:#f3f4f6;border-color:#e1e5ea;color:#202124}' +
          '@media (max-width:520px){.card{padding:18px}.h{font-size:18px}}' +
        '</style>' +
      '</head><body>' +
        '<div class="wrap"><div class="card">' +
          '<div class="top">' +
            '<div class="icon-box"><span class="face" aria-hidden="true"></span></div>' +
            '<div>' +
              '<div class="h">无法访问此网站</div>' +
              ('<div class="d"><strong>' + escapeHtml(location.hostname) + '</strong> 意外中止了连接。</div>') +
              '<ul class="suggest">' +
                '<li>检查网络连接</li>' +
                '<li>检查代理服务器和防火墙</li>' +
                '<li>运行 Windows 网络诊断</li>' +
              '</ul>' +
              '<div class="errcode">ERR_CONNECTION_CLOSED</div>' +
            '</div>' +
          '</div>' +
          '<div class="btns">' +
            '<button class="btn primary" onclick="location.reload()">重新加载</button>' +
            '<button class="btn secondary" onclick="history.back()">返回</button>' +
          '</div>' +
        '</div></div>' +
      '</body></html>';

    document.open('text/html','replace');
    document.write(html);
    document.close();
    try { window.stop && window.stop(); } catch (e) {}
    if (DEBUG) console.log("[WEDO] page replaced with faux error");
  } catch (e) {
    if (DEBUG) console.error("[WEDO] render error page failed", e);
  }

})();
